module.exports = __webpack_public_path__ + "static/media/calendar.941298c2.svg";